import type { capacite as Fr } from '../fr/capacite';

/** « capacite » in English — typed on the French: a missing sentence does not compile. */
export const capacite: typeof Fr = {
  titre: 'Cash flow & forecast',
  sousTitre: 'What you have collected is not what you have earned this month. This screen keeps the two apart.',
  glissants: 'Rolling 12 months',
  infobulle: (libelle, m) => `${libelle} — potential ${m}`,
  legende: {
    restant: 'Still to sell',
    reserve: 'Booked, not yet collected',
    encaisse: 'Booked AND already collected',
  },
  moisParMois: 'Month by month',
  colonnes: {
    mois: 'Month', potentiel: 'Max potential', reserve: 'Booked', dontEncaisse: 'of which already collected',
    restant: 'Still to sell', encaissements: 'Actual payments', ca: 'Revenue earned', remplissage: 'Occupancy',
  },
};
